import { Box, Button, Container, FormControl, FormLabel, Heading, Input, Text, Textarea, useToast, VStack } from '@chakra-ui/react'
import emailjs from '@emailjs/browser'
import { useState } from 'react'

const Contact = () => {
  const toast = useToast()
  const [isDisabled, setIsDisabled] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()

    setIsDisabled(true)
    const myForm = event.target

    emailjs
      .sendForm('service_18g8kvo', 'template_15mwya6', myForm, {
        publicKey: 'GlNs-eTbxBWqSVTQ5'
      })
      .then(() => {
        toast({
          title: 'Message sent!',
          description: 'Your message has been sent successfully.',
          status: 'success',
          duration: 2000,
          isClosable: true,
          position: 'top'
        })
        myForm.reset()
      })
      .catch((error) => {
        toast({
          title: 'Error',
          description: 'Failed to send message.',
          status: 'error',
          duration: 2000,
          isClosable: true,
          position: 'top'
        })
        console.error(error)
      })
      .finally(() => {
        setIsDisabled(false)
      })

    // const formData = new FormData(myForm)
    // const data = Object.fromEntries(formData)
    // console.log('data', data)

    // const response = await fetch('http://localhost:9999/.netlify/functions/submitForm', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(data)
    // })

    // const result = await response.json()
    // console.log(result)

    // fetch('/', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //   body: new URLSearchParams(formData).toString()
    // })
    //   .then((res) => {
    //     if (res.status === 200) {
    //       toast({
    //         title: 'Sending...',
    //         description: 'Your message is being sent.',
    //         status: 'info',
    //         duration: 2000,
    //         isClosable: true,
    //         position: 'top'
    //       })
    //     }
    //   })
    //   .catch((error) => alert(error))
  }

  return (
    <Box
      id="contact"
      bgImage={"url('/assets/images/bg-contact.jpg')"}
      bgPos={'center'}
      bgRepeat={'no-repeat'}
      bgSize={'cover'}
      color={'white'}
      py={{
        base: 14,
        md: 20
      }}>
      <Container maxW={'container.xl'}>
        <Box
          display={{
            base: 'block',
            md: 'flex'
          }}
          gap={4}
          justifyContent={'space-between'}>
          <Box>
            <Box
              display={'flex'}
              flexDirection={'column'}
              gap={{
                base: 2,
                md: 4
              }}
              // bgColor={'orange'}
              maxW={{
                md: '80%'
              }}
              mb={{
                base: 6,
                md: 12
              }}>
              <Heading
                textAlign={{
                  base: 'center',
                  md: 'left'
                }}
                fontSize={{
                  base: '1.25rem',
                  md: '3rem'
                }}>
                Contact
              </Heading>
              <Text
                textAlign={{
                  base: 'center',
                  md: 'left'
                }}
                fontSize={{
                  base: '1rem',
                  md: '1.2rem'
                }}>
                If you're interested in collaborating on a project or have any questions about my work, I would love to hear from you!
              </Text>
            </Box>
          </Box>

          <Box
            // bg={'blue'}
            width={{
              base: '100%',
              md: '500px',
              xl: '600px'
            }}>
            <form name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit}>
              <VStack spacing={4} align="stretch">
                <FormControl isRequired>
                  <FormLabel>Name</FormLabel>
                  <Input name="name" placeholder="Your Name" />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>Email</FormLabel>
                  <Input type="email" name="email" placeholder="Your Email" />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>Message</FormLabel>
                  <Textarea name="message" placeholder="Your Message" rows={5} />
                </FormControl>

                <Box display={'flex'} justifyContent={'flex-end'}>
                  <Button type="submit" bgColor={'green.600'} disabled={isDisabled}>
                    Send Message
                  </Button>
                </Box>
              </VStack>
            </form>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Contact
